/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { Calendar } from 'react-calendar';

function OrderNumbers({
    dashboardData, selected, setSelected, customDate, setCustomDate, setTrigger, selectedDate, setselectedDate,
}) {
    const dateRef = useRef();
    // const [selectedDate, setselectedDate] = useState({
    //     start_date: '',
    //     end_date: '',
    // });
    const toggleState = {
        start_date: false,
        end_date: false,
    };
    const [toggle, settoggle] = useState(toggleState);

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const handleCustom = () => {
        // handleFetch(`);
        setTrigger('CUSTOM');
        setCustomDate(!customDate);
    };
    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setselectedDate((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        handleToggle(state);
        setselectedDate((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        settoggle(toggleState);
    };

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    start_date: false,
                    end_date: false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    return (
        <div className="bg-[#F5F5FA] mt-6 rounded-[15px]">
            <div className="flex items-center mx-5">
                <p className="text-sm27 font-normal my-[28px]  text-[#555259] ">Orders</p>
                <div className={`${customDate === false ? '' : 'hidden'}`} style={{ marginLeft: '50%' }}>
                    <ul className="nav nav-pills nav-items-content  flex flex-col h-[44px] justify-center items-center rounded-[10px] my-5 md:flex-row flex-wrap list-none pl-0" id="pills-tab" role="tablist">
                        <li className={`nav-item${selected === 'DAILY' ? ' bg-[white]' : ''}`} role="presentation">
                            <a
                                href="#pills-home"
                                className={`nav-link block dashboard font-normal text-sm37 rounded px-4 py-1 my-1 focus:outline-none focus:ring-0 ${selected === 'DAILY' ? 'active' : ''}`}
                                id="pills-home-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-home"
                                role="tab"
                                aria-controls="pills-home"
                                aria-selected="true"
                                onClick={() => {
                                    setSelected('DAILY');
                                    setTrigger('DAILY');
                                    setselectedDate({
                                        start_date: '',
                                        end_date: '',
                                    });
                                }}
                            >
                                Today
                            </a>
                        </li>
                        <li className={`nav-item${selected === 'WEEKLY' ? ' bg-[white]' : ''}`} role="presentation">
                            <a
                                href="#pills-profile"
                                className={`nav-link block dashboard font-normal text-sm37 rounded px-4 py-1 my-1 focus:outline-none focus:ring-0 ${selected === 'WEEKLY' ? 'active' : ''}`}
                                id="pills-profile-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-profile"
                                role="tab"
                                aria-controls="pills-profile"
                                aria-selected="false"
                                onClick={() => {
                                    setSelected('WEEKLY');
                                    setTrigger('WEEKLY');
                                    setselectedDate({
                                        start_date: '',
                                        end_date: '',
                                    });
                                }}
                            >
                                1W
                            </a>
                        </li>
                        <li className={`nav-item${selected === 'MONTHLY' ? ' bg-[white]' : ''}`} role="presentation">
                            <a
                                href="#pills-contact"
                                className={`nav-link block dashboard font-normal text-sm37 rounded px-4 py-1 my-1 focus:outline-none focus:ring-0 ${selected === 'MONTHLY' ? 'active' : ''}`}
                                id="pills-contact-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-contact"
                                role="tab"
                                aria-controls="pills-contact"
                                aria-selected="false"
                                onClick={() => {
                                    setSelected('MONTHLY');
                                    setTrigger('MONTHLY');
                                    setselectedDate({
                                        start_date: '',
                                        end_date: '',
                                    });
                                }}
                            >
                                1M
                            </a>
                        </li>
                        <li className={`nav-item${selected === 'SIX_MONTH' ? ' bg-[white]' : ''}`} role="presentation">
                            <a
                                href="#pills-contact"
                                className={`nav-link block dashboard font-normal text-sm37 rounded px-4 py-1 my-1 focus:outline-none focus:ring-0 ${selected === 'SIX_MONTH' ? 'active' : ''}`}
                                id="pills-contact-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-contact"
                                role="tab"
                                aria-controls="pills-contact"
                                aria-selected="false"
                                onClick={() => {
                                    setSelected('SIX_MONTH');
                                    setTrigger('SIX_MONTH');
                                    setselectedDate({
                                        start_date: '',
                                        end_date: '',
                                    });
                                }}
                            >
                                6M
                            </a>
                        </li>
                        <li className={`nav-item${selected === 'YEARLY' ? ' bg-[white]' : ''}`} role="presentation">
                            <a
                                href="#pills-contact"
                                className={`nav-link block dashboard font-normal text-sm37 rounded px-4 py-1 my-1 focus:outline-none focus:ring-0 ${selected === 'YEARLY' ? 'active' : ''}`}
                                id="pills-contact-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-contact"
                                role="tab"
                                aria-controls="pills-contact"
                                aria-selected="false"
                                onClick={() => {
                                    setSelected('YEARLY');
                                    setTrigger('YEARLY');
                                    setselectedDate({
                                        start_date: '',
                                        end_date: '',
                                    });
                                }}
                            >
                                1Y
                            </a>
                        </li>
                        <li className={`nav-item${selected === 'CUSTOM' ? ' bg-[white]' : ''}`} role="presentation">
                            <a
                                href="#pills-contact"
                                className={`nav-link block dashboard font-normal text-sm37 rounded px-4 py-1 my-1 focus:outline-none focus:ring-0 ${selected === 'CUSTOM' ? 'active' : ''}`}
                                id="pills-contact-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-contact"
                                role="tab"
                                aria-controls="pills-contact"
                                aria-selected="false"
                                onClick={() => { setCustomDate(!customDate); }}
                            >
                                Custom
                            </a>
                        </li>
                    </ul>
                </div>
                <div ref={dateRef} className={`${customDate === true ? '' : 'hidden'} custom-range`} style={{ marginLeft: '50%' }}>
                    <ul className="nav nav-pills  flex flex-col  bg-[white] h-[62px] justify-center items-center rounded-[10px] my-5 md:flex-row flex-wrap list-none pl-0 " id="pills-tab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <a
                                href="#pills-custom"
                                className=" nav-link block custom font-semibold text-sm47 text-[#555259] rounded px-2 focus:outline-none focus:ring-0"
                                id="pills-custom-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-custom"
                                role="tab"
                                aria-controls="pills-custom"
                                aria-selected="true"
                            >
                                Custom Date Range
                            </a>
                            {/* <!-- custom date from and to --> */}
                            <div className="flex items-center justify-center">
                                <label htmlFor="from" className="text-sm47 pl-2">From</label>
                                <div className="relative w-[115px] mx-3">
                                    <img
                                        src="images/modal_calender.svg"
                                        alt="icon"
                                        className="absolute top-[5px] right-[7px] cursor-pointer"
                                        onClick={() => handleToggle('start_date')}
                                    />
                                    <input
                                        datepicker
                                        datepicker-autohide
                                        type="text"
                                        className="cursor-pointer h-[30px] w-full  border border-[#D3D3D3] rounded-[5px] outline-0 bg-[white] text-xs5 font-normal text-[#66728A] px-[9px] placeholder:text-[#66728A] placeholder:text-sm47 placeholder:font-normal"
                                        placeholder="DD/MM/YYYY"
                                        value={selectedDate.start_date === '' ? '' : moment(selectedDate.start_date).format('YYYY/MM/DD').split('/').reverse()
                                            .join('/')}
                                    />
                                </div>
                                {toggle.start_date && <Calendar className="z-[9999] homepage-calender" value={moment(selectedDate.start_date).format('YYYY/MM/DD').start_date} onChange={(val) => handleDate(val, 'start_date')} placeholder="Date from" />}
                                <label htmlFor="to" className="text-sm47">To</label>
                                <div className="relative w-[115px] ml-3 mr-1">
                                    <img
                                        src="images/modal_calender.svg"
                                        alt="icon"
                                        className="absolute top-[5px] right-[7px] cursor-pointer"
                                        onClick={() => handleToggle('end_date')}
                                    />
                                    <input
                                        datepicker
                                        datepicker-autohide
                                        type="text"
                                        className="cursor-pointer h-[30px]  w-full border border-[#D3D3D3] rounded-[5px]  outline-0 bg-[white] text-xs5 font-normal text-[#66728A] px-[9px] placeholder:text-[#66728A] placeholder:text-sm47 placeholder:font-normal"
                                        placeholder="DD/MM/YYYY"
                                        value={selectedDate.end_date === '' ? '' : moment(selectedDate.end_date).format('YYYY/MM/DD').split('/').reverse()
                                            .join('/')}
                                    />
                                </div>
                                {toggle.end_date && <Calendar className="z-[9999] homepage-calender" maxDate={moment().toDate()} value={moment(selectedDate.end_date).format('YYYY/MM/DD').start_date} onChange={(val) => handleDate(val, 'end_date')} minDate={moment(selectedDate.start_date).toDate()} placeholder="Date to" />}
                                <img
                                    src="images/cross-icon.svg"
                                    alt="crossicon"
                                    className="cross-icon cursor-pointer"
                                    onClick={() => {
                                        setCustomDate(!customDate);
                                        setselectedDate({
                                            start_date: '',
                                            end_date: '',
                                        });
                                    }}
                                />
                                <button className="text-sm47 font-normal ml-5 mr-[10px] text-white bg-[#555259] rounded-lg px-[20px] py-[4px]" onClick={() => { handleCustom(); }}>Apply</button>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className=" bg-white rounded-[16px] border border-[#CBC7C7] mx-[20px] pt-[35px]">
                <div className="flex w-full justify-between pb-[35px] border-[#D3D3D3]">
                    <div className=" w-[25%] px-[30px] border-r border-[#D3D3D3]">
                        <div className=" text-center ">
                            <span className="flex justify-center">
                                {' '}
                                <img src="images/pending-order.svg" alt="" />
                            </span>
                            <p className="text-sm50 font-semibold text-black">
                                {(dashboardData[`${selected.toLowerCase()}_pending_orders`] || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                            </p>
                            <p className="text-xs26 font-normal text-[#555259]">
                                Pending Orders
                                <br />
                                {' '}
                                Confirmation
                            </p>
                        </div>
                    </div>
                    <div className=" px-[30px] w-[25%] border-r border-[#D3D3D3]">
                        <div className=" text-center ">
                            <span className="flex justify-center">
                                {' '}
                                <img src="images/Approved-order.svg" alt="" />
                            </span>
                            <p className="text-sm50 font-semibold text-black">{(dashboardData[`${selected}_APPROVED_VALUE`] || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</p>
                            <span className="flex justify-center">
                                <p className="text-xs26 font-normal text-[#555259]">
                                    Approved
                                    <br />
                                    {' '}
                                    Orders
                                    {' '}
                                </p>
                            </span>
                        </div>
                    </div>
                    <div className=" px-[30px] w-[25%]  border-r border-[#D3D3D3]">
                        <div className=" text-center ">
                            <span className="flex justify-center">
                                {' '}
                                <img src="images/rejected-order.svg" alt="" />
                            </span>
                            <p className="text-sm50 font-semibold text-black">{(dashboardData[`${selected.toLowerCase()}_rejected_orders`] || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</p>
                            <span className="flex justify-center">
                                <p className="text-xs26 font-normal text-[#555259]">
                                    Rejected
                                    <br />
                                    {' '}
                                    Orders
                                </p>
                            </span>
                        </div>
                    </div>
                    <div className="px-[30px] w-[25%] text-center ">
                        <span className="flex justify-center">
                            {' '}
                            <img src="images/process-icon.png" alt="" />
                        </span>
                        <p className="text-sm50 font-semibold text-black">{(dashboardData[`${selected.toLowerCase()}_pending_orders`] || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</p>
                        <span className="flex justify-center">
                            <p className="text-xs26 font-normal text-[#555259]">
                                In-Process
                                <br />
                                {' '}
                                Orders
                            </p>
                        </span>
                    </div>
                </div>
                <div className="flex justify-between w-full mt-[40px] pb-[35px]  border-[#D3D3D3]">
                    <div className=" px-[30px] border-r w-[25%] border-[#D3D3D3]">
                        <div className="text-center ">
                            <span className="flex justify-center">
                                {' '}
                                <img src="images/delivery-order.svg" alt="" />
                            </span>
                            <p className="text-sm50 font-semibold text-black">{(dashboardData[`${selected}_VALUE`] || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</p>
                            <span className="flex justify-center">
                                {' '}
                                <p className="text-xs26 font-normal text-[#555259]">
                                    Out for
                                    <br />
                                    {' '}
                                    Delivery Orders
                                </p>
                                {' '}
                            </span>
                        </div>
                    </div>
                    <div className=" px-[30px] w-[25%] border-r border-[#D3D3D3]">
                        <div className=" text-center">
                            <span className="flex justify-center">
                                {' '}
                                <img src="images/Deliverd-order.svg" alt="" />
                            </span>
                            <p className="text-sm50 font-semibold text-black">{(dashboardData[`${selected}_VALUE`] || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</p>
                            <span className="flex justify-center">
                                <p className="text-xs26 font-normal text-[#555259]">
                                    Delivered
                                    <br />
                                    {' '}
                                    Orders
                                    {' '}
                                </p>
                            </span>
                        </div>
                    </div>
                    <div className="  px-[30px] w-[25%] border-r border-[#D3D3D3]">
                        <div className=" text-center">
                            <span className="flex justify-center">
                                {' '}
                                <img src="images/completed-order.svg" alt="" />
                            </span>
                            <p className="text-sm50 font-semibold text-black">{(dashboardData[`${selected}_VALUE`] || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</p>
                            <span className="flex justify-center">
                                <p className="text-xs26 font-normal text-[#555259]">
                                    Completed
                                    <br />
                                    {' '}
                                    Orders
                                </p>
                            </span>
                        </div>
                    </div>
                    <div className=" px-[30px] w-[25%] text-center">
                        <span className="flex justify-center">
                            {' '}
                            <img src="images/average-order.svg" alt="" />
                        </span>
                        <p className="text-sm50 font-semibold text-black">{(dashboardData[`${selected}_AVG_VALUE`] || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</p>
                        <span className="flex justify-center">
                            <p className="text-xs26 font-normal text-[#555259]">
                                Avg.Order
                                <br />
                                {' '}
                                Value
                            </p>
                        </span>
                    </div>
                </div>
            </div>
            <div className="m-5 w-full">
                <div className="flex">
                    <div className="bg-white w-[31%]  border  border-[#CBC7C7] mb-[25px] rounded-2xl text-center">
                        <p className="py-5 border-b  text-sm21 font-semibold text-[#555259]  border-[#EBEBEB]">Trade Orders</p>
                        <div className="py-5">
                            <p className="text-sm52 font-normal text-[#555259]">Orders</p>
                            <p className="text-sm50 font-semibold text-black">{(dashboardData[`${selected}_TRADE_VALUE`] ? dashboardData[`${selected}_TRADE_VALUE`].split('-')[0] : 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</p>
                            <p className="text-sm52 font-normal pt-5 text-[#555259]">Order Value</p>
                            <p className="text-sm50 font-semibold text-black">
                                ₹
                                {Number(dashboardData[`${selected}_TRADE_VALUE`] ? dashboardData[`${selected}_TRADE_VALUE`].split('-')[1] : 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                            </p>
                            <p className="text-sm52 font-normal pt-5 text-[#555259]">Billing Value</p>
                            <p className="text-sm50 font-semibold  text-black">
                                ₹
                                {Number(dashboardData[`${selected}_TRADE_VALUE`] ? dashboardData[`${selected}_TRADE_VALUE`].split('-')[2] : 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                            </p>
                        </div>
                    </div>
                    <div className="bg-white w-[31%] ml-5  border  border-[#CBC7C7] mb-[25px] rounded-2xl text-center">
                        <p className="py-5 border-b  text-sm21 font-semibold text-[#555259]  border-[#EBEBEB]">EUB Orders</p>
                        <div className="py-5">
                            <p className="text-sm52 font-normal text-[#555259]">Orders</p>
                            <p className="text-sm50 font-semibold text-black">{(dashboardData[`${selected}_EUB_VALUE`] ? dashboardData[`${selected}_EUB_VALUE`].split('-')[0] : 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</p>
                            <p className="text-sm52 font-normal pt-5 text-[#555259]">Order Value</p>
                            <p className="text-sm50 font-semibold text-black">
                                ₹
                                {Number(dashboardData[`${selected}_EUB_VALUE`] ? dashboardData[`${selected}_EUB_VALUE`].split('-')[1] : 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                            </p>
                            <p className="text-sm52 font-normal pt-5 text-[#555259]">Billing Value</p>
                            <p className="text-sm50 font-semibold  text-black">
                                ₹
                                {Number(dashboardData[`${selected}_EUB_VALUE`] ? dashboardData[`${selected}_EUB_VALUE`].split('-')[2] : 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                            </p>
                        </div>
                    </div>
                    <div className="bg-white w-[31%] ml-5  border  border-[#CBC7C7] mb-[25px]  rounded-2xl text-center">
                        <p className="py-5 border-b  text-sm21 font-semibold text-[#555259]  border-[#EBEBEB]">Direct Orders</p>
                        <div className="py-5">
                            <p className="text-sm52 font-normal text-[#555259]">Orders</p>
                            <p className="text-sm50 font-semibold text-black">{(dashboardData[`${selected}_DIRECT_VALUE`] ? dashboardData[`${selected}_DIRECT_VALUE`].split('-')[0] : 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</p>
                            <p className="text-sm52 font-normal pt-5 text-[#555259]">Order Value</p>
                            <p className="text-sm50 font-semibold text-black">
                                ₹
                                {Number(dashboardData[`${selected}_DIRECT_VALUE`] ? dashboardData[`${selected}_DIRECT_VALUE`].split('-')[1] : 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                            </p>
                            <p className="text-sm52 font-normal pt-5 text-[#555259]">Billing Value</p>
                            <p className="text-sm50 font-semibold  text-black">
                                ₹
                                {Number(dashboardData[`${selected}_DIRECT_VALUE`] ? dashboardData[`${selected}_DIRECT_VALUE`].split('-')[2] : 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default OrderNumbers;
